import React, { useState, useEffect } from "react";
import {
    FaTimes, FaChartLine, FaClock, FaPlayCircle, FaFlask, FaCheckCircle,
    FaHtml5, FaCss3, FaNodeJs, FaBootstrap, FaReact, FaVuejs,
    FaPhp, FaSwift, FaPython, FaNode, FaJava, FaCalculator,
    FaBrain, FaRobot, FaDatabase, FaLayerGroup, FaShareSquare,
    FaChevronRight, FaChevronLeft, FaRegCircle
} from "react-icons/fa";
import "./StatisticsModal.css";
import CONFIG from "../config";
import CourseCharts from "./CourseCharts";
import StatisticsInfoModal from "../Taxrirlovchi/StatisticsInfoModal";
import { FaInfoCircle } from "react-icons/fa";

const iconMap = {
    FaHtml5, FaCss3, FaNodeJs, FaBootstrap, FaReact, FaVuejs,
    FaPhp, FaSwift, FaPython, FaNode, FaJava, FaCalculator,
    FaBrain, FaRobot, FaDatabase, FaLayerGroup,
    FaShareSquare,
    FaPaperPlane: FaShareSquare,
    FaAndroid: FaHtml5,
    FaApple: FaHtml5
};

const StatisticsModal = ({ isOpen, onClose, userData }) => {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [showCharts, setShowCharts] = useState(false);
    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
        if (isOpen) {
            fetchStats();
        } else {
            setSelectedCourse(null);
            setShowCharts(false);
        }
    }, [isOpen]);

    const fetchStats = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("loyiha_token");
            const userId = userData?.id || "";
            const res = await fetch(`${CONFIG.API_BASE_URL}/get_statistics.php`, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).then(r => r.json());

            if (res.status === 'success') {
                setStats(res.data);
            }
        } catch (err) {
            console.error("Stats fetch error:", err);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    const renderCourseStats = () => (
        <div className="course-stats-grid">
            {stats.map((course) => {
                const CourseIcon = iconMap[course.icon] || FaShareSquare;
                return (
                    <div key={course.id} className="course-stat-card" onClick={() => setSelectedCourse(course)}>
                        <div className="card-top">
                            <div className="course-info">
                                <div className="course-name-row">
                                    <div className="course-title-wrapper">
                                        <CourseIcon className="course-type-icon" />
                                        <span className="course-name">{course.nomi}</span>
                                    </div>
                                    <div className="progress-pill">
                                        <span className="progress-text">{course.progress}%</span>
                                    </div>
                                </div>
                                <div className="progress-bar-wrapper">
                                    <div
                                        className="progress-fill"
                                        style={{ width: `${course.progress}%` }}
                                    ></div>
                                </div>
                            </div>
                        </div>

                        <div className="card-metrics">
                            <div className="metric-item">
                                <FaFlask className="metric-icon test-icon" />
                                <div className="metric-details">
                                    <span className="metric-label">Test natijasi</span>
                                    <span className="metric-value">{course.test_results.total_score}/{course.test_results.max_score}</span>
                                </div>
                            </div>

                            <div className="metric-item">
                                <FaPlayCircle className="metric-icon video-icon" />
                                <div className="metric-details">
                                    <span className="metric-label">Video ko'rildi</span>
                                    <span className="metric-value">{course.time_spent.video_watched_minutes} min</span>
                                </div>
                            </div>

                            <div className="metric-item">
                                <FaClock className="metric-icon time-icon" />
                                <div className="metric-details">
                                    <span className="metric-label">Testda vaqt</span>
                                    <span className="metric-value">{course.time_spent.test_taking_minutes} min</span>
                                </div>
                            </div>

                            <div className="metric-item">
                                <FaCheckCircle className="metric-icon complete-icon" />
                                <div className="metric-details">
                                    <span className="metric-label">O'zlashtirilgan</span>
                                    <span className="metric-value">{course.completed_lessons}/{course.total_lessons}</span>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <span>Batafsil ko'rish</span>
                            <FaChevronRight />
                        </div>
                    </div>
                );
            })}
        </div>
    );

    const renderTopicDetails = () => (
        <div className="topic-details-view">
            <div className="details-header">
                <button className="back-btn" onClick={() => setSelectedCourse(null)}>
                    <FaChevronLeft /> Ortga
                </button>
                <h3 style={{ flex: 1 }}>{selectedCourse.nomi}</h3>
                <button className="stats-toggle-btn" onClick={() => setShowCharts(true)} style={{
                    display: 'flex', alignItems: 'center', gap: '8px',
                    padding: '8px 16px', borderRadius: '10px', border: 'none',
                    background: '#8b4715', color: 'white', cursor: 'pointer', fontWeight: 'bold'
                }}>
                    <FaChartLine /> Grafik Tahlil
                </button>
            </div>
            <div className="topics-list">
                {selectedCourse.topics.map((topic, index) => (
                    <div
                        key={topic.id}
                        className={`topic-item ${topic.ball >= 4 ? 'passed' : ''}`}
                        style={{ '--index': index }}
                    >
                        <div className="topic-info">
                            <span className="topic-index">{index + 1}.</span>
                            <span className="topic-name">{topic.nomi}</span>
                        </div>
                        <div className="topic-results">
                            <div className="topic-result-badge" title="Video ko'rish vaqti">
                                <FaPlayCircle /> {topic.video_vaqt} m
                            </div>
                            <div className="topic-result-badge" title="Test ishlash vaqti">
                                <FaClock /> {topic.test_vaqt} m
                            </div>
                            <div className="topic-result-badge" title="Urinishlar">
                                <FaRegCircle /> {topic.urinishlar}
                            </div>
                            <div className={`topic-result-badge ${topic.ball >= 4 ? 'success' : ''}`} title="Ball">
                                <FaFlask /> {topic.ball}/5
                            </div>
                            {topic.ball >= 4 ? (
                                <FaCheckCircle className="topic-done-icon" />
                            ) : (
                                <div className="topic-pending-icon"></div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <div className="stats-modal-overlay" onClick={onClose}>
            <div className="stats-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="stats-header">
                    <div className="header-title">
                        <FaChartLine className="header-icon" />
                        <h2>O'quv Statistikasi</h2>
                    </div>
                    <button className="close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="stats-body">
                    {loading ? (
                        <div className="stats-loading">
                            <div className="loader"></div>
                            <p>Ma'lumotlar yuklanmoqda...</p>
                        </div>
                    ) : stats.length > 0 ? (
                        selectedCourse ? (
                            showCharts ? (
                                <div className="charts-view-wrapper">
                                    <div className="details-header">
                                        <button className="back-btn" onClick={() => setShowCharts(false)}>
                                            <FaChevronLeft /> Jadvalga qaytish
                                        </button>
                                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                            <h3>{selectedCourse.nomi} - Grafik Tahlil</h3>
                                            <FaInfoCircle
                                                className="info-icon-btn"
                                                title="Baholash tizimi haqida"
                                                onClick={() => setShowInfo(true)}
                                                style={{ color: '#999', cursor: 'pointer', fontSize: '16px' }}
                                            />
                                        </div>
                                    </div>
                                    <CourseCharts course={selectedCourse} />
                                </div>
                            ) : renderTopicDetails()
                        ) : renderCourseStats()
                    ) : (
                        <div className="no-stats">
                            <p>Hozircha statistika mavjud emas. Kurslarni o'rganishni boshlang!</p>
                        </div>
                    )}
                </div>
            </div>
            <StatisticsInfoModal isOpen={showInfo} onClose={() => setShowInfo(false)} mode="course" />
        </div>
    );
};

export default StatisticsModal;
